import * as React from 'react';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import glamorous from 'glamorous';
import { RvLoader } from '../../components/Loader';
import { SearchCriteria } from '../SearchCriteria';
import CloseIcon from '@material-ui/icons/Close';
import { ChartCommonProps, IconButtonWrapper, ChartCommonState, HelpWrapper } from '../Common';
import { formatNumber, GetArrow, FormatDate, getSuggestedMaxTick, getMaxTickLimit, getLabels } from '../../helpers/ChartHelper';
import { WithStyles, withStyles, FormControl, RadioGroup, FormControlLabel, Radio, IconButton } from '@material-ui/core';
import { styles } from '../styles';
import { ChartFilter } from '../ChartComponents';
import { DrillDownType } from '../DrillDownType';
import { SelectedItemProps } from '../MattersByStatusChart';

import { Bar, getElementAtEvent } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    Scale,
    Tick,
    Chart,
    ChartEvent,
    ActiveElement,
} from 'chart.js';
import zoomPlugin from 'chartjs-plugin-zoom';
import { ChartInfo } from '../../components/ChartInfo';

import { RV_CHART_CLASS, RV_CHART_COLORS, isChartDataEmpty, rvBarDatasetStyle, rvChartAnimation, rvCategoryAxisStyle, rvTooltipStyle, rvValueAxisStyle } from '../chartTheme';
import { ChartHeading } from '../ChartHeading';
import { AnimatedNumber } from '../AnimatedNumber';
import { ChartSkeleton } from '../../components/loading/ChartSkeleton';
import { ChartEmptyState } from '../ChartEmptyState';
import { ChartNotes } from '../ChartNotes';
import ReceiptOutlinedIcon from '@material-ui/icons/ReceiptOutlined';
ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    zoomPlugin
);

// tslint:disable-next-line:no-any
const CardWrapper = glamorous.div<{ theme?: any }>(props => ({
    // padding: 15,
    display: 'flex',
    flexFlow: 'column',
    textAlign: 'center',
    // fontSize: '18px',
    height: '100%',
    borderRadius: '8px',
    backgroundColor: '#FFFFFF',
    boxShadow: '0 0 14px 0 rgba(81,115,255,0.09)',
    width: '100%',
    '@media print': {
        alignItems: 'center',
        boxShadow: 'none !important'
    }
}));

const BarWrapper = glamorous.div<{ theme?: object }>((props) => ({
    position: 'relative',
    paddingBottom: '10px',
    flex: 1,
    display: 'flex',
    flexFlow: 'column',
    maxWidth: '100%',
    maxHeight: '100%',
    height: '100%',
}));

const BarTitleContainer = glamorous.div<{ theme?: object }>((props) => ({
    display: 'flex',
    flexFlow: 'column',
    alignItems: 'center',
    padding: '15px 15px 0px 15px',
    fontSize: '16px',
    fontWeight: 600,
    [`& .${`h1`}`]: {

    },
    [`& .${`h2`}`]: {
        fontSize: '2.5rem',
        padding: '10px 0',
    },
})).withProps({ className: 'rv-chart-title-area' });

const BarContainer = glamorous.div<{ theme?: object }>((props) => ({
    padding: '5px 15px 15px 15px',
    minHeight: '300px',
    flex: 1,
    display: 'flex',
    flexFlow: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    maxHeight: '350px',
    maxWidth: 'auto',
    position: 'relative',
    '@media (max-width: 533px)': {
        maxWidth: '350px',
        margin: '0 auto',
    },
    [`& .${`titleWrapper`}`]: {
        textAlign: 'center',
        display: 'inline-block',
        width: '100%',
        padding: '15px',
        [`& .${`title`}`]: {
            fontSize: '18px',
            fontWeight: 600,
            display: 'block',
            marginBottom: '15px',
        },
        [`& .${`value`}`]: {
            fontSize: '24px',
            fontWeight: 600,
            display: 'block',
            marginBottom: '15px',
        },
        [`& .${`secondary-title`}`]: {
            fontSize: '16px',
            fontWeight: 400,
            display: 'block',
            marginBottom: '15px',
        }
    }
}));

const LoadWrapper = glamorous.div<{ theme?: object }>((props) => ({
    padding: '20px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
}));

const TotalDiv = glamorous.div<{ theme?: object }>((props) => ({
    cursor: 'pointer',
    paddingRight: 5
}));

const FormControlWrapper = glamorous(FormControl) ({
    width: '100%',
    marginBottom: 10,
    padidng: '0 15px',
    '& .MuiFormGroup-root': {
        flexFlow: 'row',
        alignItems: 'center',
        justifyContent: 'center',
    },
    '& span.MuiButtonBase-root': {
        marginBottom: 0
    }
});

export interface QueryDefaultType {
    loading?: boolean;
    // tslint:disable-next-line: no-any
    result?: any;
    // tslint:disable-next-line: no-any
    error?: any;
}

interface ChartProps extends SelectedItemProps, ChartCommonProps, WithStyles<typeof styles> {
    chartFilter?: ChartFilter;
}
export enum LastCountEnum {
    PREV_MONTH,
    MONTH,
}

interface ChartState extends ChartCommonState {
    last: LastCountEnum;
}

class InvoiceFeesBilledInLastMonthChart extends React.Component<ChartProps, ChartState>  {

    // tslint:disable-next-line: no-any
    public chartRef: React.RefObject<any>;

    constructor(props: ChartProps, state: ChartState) {
        super(props, state);
        this.onCloseChart = this.onCloseChart.bind(this);
        this.handlePopoverOpen = this.handlePopoverOpen.bind(this);
        this.handlePopoverClose = this.handlePopoverClose.bind(this);
        this.handleTotalClick = this.handleTotalClick.bind(this);
        this.onChangeRadio = this.onChangeRadio.bind(this);
        this.onHover = this.onHover.bind(this);

        this.onPan = this.onPan.bind(this);

        this.chartRef = React.createRef();

        this.state = {
            open: false,
            anchorEl: undefined,
            last: LastCountEnum.MONTH
        };
    }

    public componentDidMount() {
        // 
    }

    public componentWillUnmount() {
        // 
    }
    
    public onChangeRadio (event: React.ChangeEvent<HTMLInputElement>) {
        event.persist();
        this.setState((prevState) => {
            return {
                ...prevState,
                // tslint:disable-next-line: radix
                last: parseInt((event.target as HTMLInputElement).value)
            };
        });
    }

    public render() {        
        // const { classes } = this.props;
        var symbol = '';

        return (
            <React.Fragment>
                {/* tslint:disable-next-line: no-any */}
                <Query<any> 
                            query={CurrencySymbol}
                            variables={{
                                entityType: this.props.chartFilter?.entityType,
                                entityGuid: this.props.chartFilter?.entityGuid,
                                responsibility: this.props.chartFilter?.responsibility
                            }}
                >
                    {(result) => {

                        if (result.loading) {
                            return (
                                <ChartSkeleton variant="columns" />
                            );
                        }

                        const currencySymbol = (result.loading || result.error) ?
                            null : result.data.options.currencySymbol;

                        symbol = currencySymbol ? currencySymbol.symbol : null;

                        return (            
                            <CardWrapper>
                                {/* tslint:disable-next-line: no-any */}
                                <Query<any> 
                                    query={ChartData}
                                    variables={{
                                        entityType: this.props.chartFilter?.entityType,
                                        entityGuid: this.props.chartFilter?.entityGuid,
                                        responsibility: this.props.chartFilter?.responsibility
                                    }}
                                > 
                                        {({ loading, error, data }) => {
                
                                        if (loading) {
                                            return (
                                                <LoadWrapper className="load-wrapper">
                                                    <RvLoader size="small" />
                                                </LoadWrapper>
                                            );
                                        }
                
                                        const statistics = data.statistics;
                
                                        let invoice = (loading || error ||
                                            statistics === null || statistics === undefined)
                                            ? null
                                            : statistics.invoice;
                
                                        let invoiceFeesBilledInLastMonth = invoice ? invoice.invoiceFeesBilledInLastMonth : null;
                
                                        if (invoiceFeesBilledInLastMonth) {
                                            // tslint:disable-next-line:max-line-length
                                            const lastTwelveMonthsTotalCount = invoiceFeesBilledInLastMonth.invoiceMonthTotalCount.currentMonthTotalCount;
                                            // tslint:disable-next-line:max-line-length
                                            const previousTwelveMonthsTotalCount = invoiceFeesBilledInLastMonth.invoiceMonthTotalCount.previousMonthTotalCount;
                
                                            let months: string[] = [];
                                            let counts: number[] = [];

                                            let highestValue = 0;

                                            if (this.state.last === LastCountEnum.MONTH) {
                                                 // tslint:disable-next-line: no-any
                                                months = invoiceFeesBilledInLastMonth.invoiceByDate.map((value: any) => { 
                                                    return FormatDate(value.date); });
                    
                                                // tslint:disable-next-line: no-any
                                                counts = invoiceFeesBilledInLastMonth.invoiceByDate.map((value: any) => { 
                                                    if (value.count > highestValue) {
                                                        highestValue = value.count;
                                                    }
                                                    return value.count; 
                                                });
                                            } else {
                                                // tslint:disable-next-line: no-any
                                                months = invoiceFeesBilledInLastMonth.previousInvoiceByDate.map((value: any) => { 
                                                   return FormatDate(value.date); });

                                                // tslint:disable-next-line: no-any
                                                counts = invoiceFeesBilledInLastMonth.previousInvoiceByDate.map((value: any) => { 
                                                    if (value.count > highestValue) {
                                                        highestValue = value.count;
                                                    }
                                                    return value.count; 
                                                });
                                           } 
                           
                                            return (
                                                <BarWrapper className={RV_CHART_CLASS}>
                                                    <IconButtonWrapper
                                                        aria-label="close"
                                                    >
                                                        <HelpWrapper className="rv-chart-help">
                                                            <ChartInfo 
                                                                description={this.props.description}
                                                            />
                                                        </HelpWrapper>
                                                        <IconButton
                                                            aria-label="close"
                                                            onClick={this.onCloseChart}
                                                            size="small"
                                                        >
                                                            <CloseIcon />
                                                        </IconButton>
                                                    </IconButtonWrapper>
                                                    <BarTitleContainer>
                                                        <ChartHeading icon={<ReceiptOutlinedIcon />} title="Fees Billed This Month" />
                                                        <TotalDiv className="h2" onClick={() => this.handleTotalClick(true)}>
                                                            <AnimatedNumber value={lastTwelveMonthsTotalCount} format={(amount) => symbol + formatNumber(amount)} />
                                                            {GetArrow(lastTwelveMonthsTotalCount, previousTwelveMonthsTotalCount)}
                                                        </TotalDiv>
                                                        <div className="h3" onClick={() => this.handleTotalClick(true)}>
                                                            <TotalDiv>
                                                                {symbol + formatNumber(previousTwelveMonthsTotalCount)} in the previous month
                                                            </TotalDiv>
                                                        </div>
                                                    </BarTitleContainer>
                                                    <BarContainer className="rv-chart-bars">
                                                        <Bar
                                                            ref={this.chartRef}
                                                            // tslint:disable-next-line: no-any
                                                            onClick={(event: React.MouseEvent<any>) => {
                                                                const _data = getElementAtEvent(this.chartRef.current, event);
                                                                if (_data.length > 0 && this.props.getSelectedItem) {
                
                                                                    const _index = getElementAtEvent(this.chartRef.current, event)[0].index;
                
                                                                    const item = months[_index];
    
                                                                    const searchCriterias = new Array<SearchCriteria>();
    
                                                                    // . e.g. - Apr 22, Apr 23, etc
                                                                    searchCriterias.push(
                                                                        { property: 'Status', operator: 'in', comparison: 'Billed' },
                                                                        { property: 'InvoiceDateShortString', operator: 'eq', comparison: item }
                                                                    );
                
                                                                    this.props.getSelectedItem(
                                                                        searchCriterias,
                                                                        false,
                                                                        'Fees Billed this month - ' + item,
                                                                        DrillDownType.invoiceSummary,
                                                                        'Invoices'
                                                                    );
                                                                }
                                                            }}
                                                            
                                                            data={{
                                                                labels: getLabels(months),
                                                                datasets: [
                                                                    {
                                                                        // fill: false,
                                                                        label: 'Fees Billed',
                                                                        ...rvBarDatasetStyle(RV_CHART_COLORS.primary),
                                                                        data: counts,
                                                                        type: 'bar'
                                                                    }
                                                                ]
                                                            }}
                                                            options={{
                                                                onHover: this.onHover,
                                                                indexAxis: 'x' as const,
                                                                animation: rvChartAnimation(),
                                                                elements: { bar: { borderWidth: 0 } },
                                                                responsive: true,
                                                                maintainAspectRatio: false,
                                                                scales: {
                                                                  y: {
                                                                    grid: rvValueAxisStyle.grid,
                                                                    // beginAtZero: true,
                                                                    suggestedMax: getSuggestedMaxTick(counts),
                                                                    beginAtZero: true,
                                                                    ticks: {
                                                                        ...rvValueAxisStyle.ticks,
                                                                        maxTicksLimit: getMaxTickLimit(counts),
                                                                        autoSkip: false,
                                                                        callback: function (this: Scale, tickValue: number, index: number, ticks: Tick[]) {
                                                                            return `${symbol}${formatNumber(tickValue)}`;
                                                                        }
                                                                    }
                                                                  },
                                                                  x: {
                                                                    grid: rvCategoryAxisStyle.grid,
                                                                    // min: 0,
                                                                    // max: 9 // minimum display
                                                                    ticks: {
                                                                        ...rvCategoryAxisStyle.ticks,
                                                                        autoSkip: false
                                                                    }
                                                                  }
                                                                },
                                                                plugins: {
                                                                  legend: {
                                                                    position: 'bottom' as const,
                                                                    display: false
                                                                  },
                                                                  title: {
                                                                    display: false,
                                                                    text: `Fees Billed in the last month: ${symbol + formatNumber(lastTwelveMonthsTotalCount)}`,
                                                                  },
                                                                  zoom: {
                                                                    pan: {
                                                                      enabled: false,
                                                                      onPan: this.onPan
                                                                    },
                                                                    zoom: {
                                                                      wheel: {
                                                                        enabled: false
                                                                      }
                                                                    }
                                                                    // limits: {
                                                                    //   y: { min: 0, max: 9 },
                                                                    // },
                                                                  },
                                                                  tooltip: {
                                                                    ...rvTooltipStyle,
                                                                    callbacks: {
                                                                        // tslint:disable-next-line: no-any
                                                                        label: function (context: any) {
                                                                            const { 
                                                                                //   dataIndex, 
                                                                                //   label, 
                                                                                formattedValue,
                                                                                //   dataset 
                                                                            } = context;
                    
                                                                            var currentValue = parseFloat(formattedValue.replace(/,/g, ''));
        
                                                                            return `Fees Billed: ${symbol}${formatNumber(currentValue)}`;
                                                                        },
                                                                    }
                                                                  }
                                                                },
                                                            }}
                                                        />
                                                        {isChartDataEmpty(counts) && (
                                                            <ChartEmptyState title="No data" hint="Nothing to show for this selection." />
                                                        )}
                                                    </BarContainer>
                                                    <FormControlWrapper>
                                                        <RadioGroup 
                                                            name="last" 
                                                            value={this.state.last} 
                                                            onChange={this.onChangeRadio}
                                                        >
                                                            <FormControlLabel 
                                                                value={LastCountEnum.MONTH} 
                                                                control={<Radio color="primary" />} 
                                                                label="This Month" 
                                                            />
                                                            <FormControlLabel 
                                                                value={LastCountEnum.PREV_MONTH} 
                                                                control={<Radio color="primary" />} 
                                                                label="Previous Month" 
                                                            />
                                                        </RadioGroup>
                                                    </FormControlWrapper>
                                                    <ChartNotes notes={['Information collated based on matter responsibility']} actionHint="Drill down to invoice details" />

                                                </BarWrapper>
                                            );
                                        }
                
                                        return (
                                            <LoadWrapper className="load-wrapper">
                                                <RvLoader size="small" />
                                            </LoadWrapper>
                                        );
                                    }}
                                </Query>                
                            </CardWrapper>
                        );
                    }}
                </Query>
            </React.Fragment>
        );
    }

    private handleTotalClick(isCurrent: Boolean) {
        if (this.props.getSelectedItem) {
            const searchCriterias = new Array<SearchCriteria>();

            searchCriterias.push(
                { property: 'Status', operator: 'in', comparison: 'Billed' },
                { property: 'InvoiceThisMonth', operator: 'eq', comparison: isCurrent ? 'curr' : 'prev'}
            );

            this.props.getSelectedItem(
                searchCriterias,
                false,
                'Fees Billed this month',
                DrillDownType.invoiceSummary,
                'Invoices'
            );
        }        
    }

    private onCloseChart() {
        if (this.props.onCloseChart) {
            return this.props.onCloseChart('isFeesBilledForMonthOpen');
        }
    }

    // tslint:disable-next-line: no-any
    private handlePopoverOpen(event: any) {
        this.setAnchorEl(event.currentTarget);
    }

    private handlePopoverClose = () => {
        this.setAnchorEl(null);
    }

    // tslint:disable-next-line: no-any
    private setAnchorEl(anchorElValue: any) {
        this.setState({
            anchorEl: anchorElValue,
            open: Boolean(anchorElValue)
        });
    }

    private onPan = (context: { chart: Chart }) => {
        this.chartRef.current.options.scales.y.min = 0;
        this.chartRef.current.update();
    }

    private onHover(event: ChartEvent, elements: ActiveElement[], chart: Chart) {
        (event?.native?.target as HTMLElement).style.cursor = elements.length > 0 ? 'pointer' : 'auto';
    }
}

// tslint:disable-next-line: no-any
export default withStyles(styles as any, { withTheme: true })(InvoiceFeesBilledInLastMonthChart as any) as any;

const CurrencySymbol = gql`query CurrencySymbol {
    options {currencySymbol {symbol}}
}`;

const ChartData = gql`query InvoiceFeesBilledInLastMonth ($entityType: Int, $entityGuid: String, $responsibility: Int) {
    statistics {
        invoice {
            invoiceFeesBilledInLastMonth (entityType: $entityType, entityGuid: $entityGuid, responsibility: $responsibility) {
                invoiceMonthTotalCount {
                    previousMonthTotalCount
                    currentMonthTotalCount
                }
                invoiceByDate {
                    date
                    count
                }
                trend {
                    date
                    count
                }
                previousInvoiceByDate {
                    date
                    count
                }
                previousTrend {
                    date
                    count
                }
          }          
        }
    }
}`;
